import { Avatar, Box, Divider, Typography } from "@mui/material";

export default function FormHeader({ icon, title, subtitle, description }) {
  return (
    <Box
      sx={{
        textAlign: "center",
        mb: 5,
      }}
    >
      <Avatar
        sx={{
          width: 72,
          height: 72,
          bgcolor: "primary.main",
          mx: "auto",
          mb: 2,
        }}
      >
        {icon}
      </Avatar>

      <Typography variant="h4" fontWeight={700} gutterBottom>
        {title}
      </Typography>

      {subtitle && (
        <Typography variant="h6" color="text.secondary">
          {subtitle}
        </Typography>
      )}

      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mt: 1,
            maxWidth: 520,
            mx: "auto",
          }}
        >
          {description}
        </Typography>
      )}

      <Divider sx={{ mt: 4 }} />
    </Box>
  );
}
